
export default "/assets/device-tablet-micro.5579a038.svg"